import type { IntegrationAbilityInfo } from '@core/integrations-http-legacy';
import { createSingleEntityStore } from '@core/ngrx-legacy';

const { actions, namespace, reducer, selectors } = createSingleEntityStore<
  IntegrationAbilityInfo[]
>()('integration-abilities', {
  customActions: adapter => ({
    fetch: (state, payload: { kinds: string[] }) => adapter.markAsPending(state),
  }),
});

// const IntegrationAbilitiesActions: Pick<typeof actions, 'fetch' | 'fetchSuccess' | 'fetchFailed'> =
//   actions;

export {
  actions as IntegrationAbilitiesActions,
  namespace as IntegrationAbilitiesNamespace,
  reducer as IntegrationAbilitiesReducer,
  selectors as IntegrationAbilitiesSelectors,
};
